export default "<router-outlet></router-outlet>\n\n<ng-http-loader [minDuration]=\"1000\" [extraDuration]=\"800\"></ng-http-loader>"